import { Alert, Button, SaveIcon, Stack } from '@all-manager/design-system-v2';
import DescriptionFieldOk from "../../../../components/modals/components/DescriptionFieldOk";
import { SubTopicDatabase } from "../../../../types";
import { useNotesTab } from "./useNotesTab";

type Props = {
  subTopic: SubTopicDatabase;
};

export default function NotesTab(props: Props) {
  const { form, handleSave, isSaving, serverError, isAdmin } = useNotesTab(props.subTopic);

  return (
    <Stack spacing={2}>
      {serverError && (
        <Alert severity="error">{serverError}</Alert>
      )}

      <DescriptionFieldOk
        form={form}
        name="notes"
        label=""
        readOnly={!isAdmin}
      />
      {isAdmin ? (
      <Stack direction="row" justifyContent="center">
        <Button
          variant="contained"
          onClick={handleSave}
          loading={isSaving}
          startIcon={<SaveIcon />}
        >
          Sauvegarder
        </Button>
      </Stack>
      ) : null}
    </Stack>
  );
}
